import React, { Component } from 'react'
import { observer } from 'mobx-react'

import WizardStore from './WizardStore'
import SurveyWizardLayout from '../Layouts/SurveyWizard'
import { getQueryParam } from '../../utils/helpers'

import './survey-wizard.scss'

const BREADCRUMPS = {
    EM: {
        url: '',
        title: 'New Maxbi Entry',
        name: 'new maxbi entry',
    },
    R: {
        url: '',
        title: 'New Rapid Survey',
        name: 'new rapid survey',
    },
    T: {
        url: '',
        title: 'New Template',
        name: 'new template',
    },
    others: {
        url: '',
        title: 'New Survey',
        name: 'new survey',
    },
}

@observer
class SurveyWizard extends Component {
    constructor(props) {
        super(props)
        this.industry = this.getPathname()
        this.surveyType = this.getParams()
        this.wizardStore = new WizardStore(props.appStore, this.industry, this.surveyType)

        props.appStore.breadcrumps = [BREADCRUMPS[this.surveyType ?? 'others']]
    }

    componentWillUnmount() {
        const { appStore } = this.props
        try {
            Reflect.deleteProperty(appStore, 'survey')
            Reflect.deleteProperty(appStore, 'surveyToken')
        } catch (e) {
            console.log('error: ', e)
        }
    }

    getPathname = () => {
        const { history } = this.props
        const pathName = history.location.pathname
        const paths = pathName.split('/')
        return paths[paths.length - 1]
    }

    getParams = () => {
        const { history } = this.props
        const surveyType = getQueryParam(history.location, 'surveytype')
        return surveyType !== -1 ? surveyType : undefined
    }

    render() {
        return (
            <SurveyWizardLayout
                wizardStore={this.wizardStore}
                stages={this.wizardStore.stages}
                curStage={this.wizardStore.curStage}
            />
        )
    }
}

export default SurveyWizard
